export default __webpack_public_path__ + "static/media/custom-form.511de3ad.jpg";